import {
  MessageSequenceStatus,
  RebillMessagesRestControllerService,
} from '@api'

import type { RebillMessage } from '@/modules/creator-settings/rebill-messages/types.ts'

export function createRebillMessage(creatorId: number, message: RebillMessage) {
  return RebillMessagesRestControllerService.createRebillMessage({
    creatorId,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requestBody: message as any, // TODO: need to fix FE types for message
  })
}

export function updateRebillMessage(creatorId: number, message: RebillMessage) {
  return RebillMessagesRestControllerService.edit({
    creatorId,
    messageId: message.id!,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requestBody: message as any, // TODO: need to fix FE types for message
  })
}

export function toggleRebillMessages(creatorId: number, value: boolean) {
  return RebillMessagesRestControllerService.apiToggleRebillMessages({
    creatorId,
    requestBody: value,
  })
}

export function updateRebillMessageToggle(
  creatorId: number,
  messageId: string,
  value: MessageSequenceStatus,
) {
  return RebillMessagesRestControllerService.apiToggleMessageActivation({
    creatorId,
    messageId: parseInt(messageId),
    requestBody: value,
  })
}

export function deleteRebillMessage(creatorId: number, messageId: string) {
  return RebillMessagesRestControllerService.deleteRebillMessage({
    creatorId,
    messageId: parseInt(messageId),
  })
}

export function updateRebillMessagesMinutes(creatorId: number, value: number) {
  return RebillMessagesRestControllerService.apiSetSendAfterMinutes({
    creatorId,
    requestBody: value,
  })
}

export function updateRebillMessagesHoursSinceLastMessage(
  creatorId: number,
  value: number,
) {
  return RebillMessagesRestControllerService.apiSetMinHoursSinceLastMessage({
    creatorId,
    requestBody: value,
  })
}

export const rebillMessageService = {
  create: createRebillMessage,
  update: updateRebillMessage,
  pageToggle: toggleRebillMessages,
  messageToggle: updateRebillMessageToggle,
  delete: deleteRebillMessage,
  updateMinutes: updateRebillMessagesMinutes,
  updateHours: updateRebillMessagesHoursSinceLastMessage,
}
